import { Col, ProgressBar, Row } from "react-bootstrap";

export interface IApplicationTrackerStatus {
  value: string;
  label: string;
}

export interface IApplicationTrackerProps {
  availableStatuses: IApplicationTrackerStatus[];
  currentStatus: string;
}

const pendingProgressBackgroundColor = "#ddd";

export const DynamicApplicationTracker = ({
  availableStatuses,
  currentStatus,
}: IApplicationTrackerProps) => {
  const progressWidth = 100 / availableStatuses.length;
  let hasReachedCurrentStatus = false;

  let progressBarElements = [] as JSX.Element[];
  let progressBarLabelElements = [] as JSX.Element[];
  let currentProgressBarElement: JSX.Element;
  let currentProgressBarLabelElement: JSX.Element;
  for (let i = 0; i < availableStatuses.length - 1; i++) {
    if (availableStatuses[i].value === currentStatus) {
      hasReachedCurrentStatus = true;
      currentProgressBarElement = (
        <ProgressBar variant="primary" now={progressWidth / 2} key={i} />
      );
    } else {
      if (hasReachedCurrentStatus) {
        currentProgressBarElement = (
          <ProgressBar
            style={{ backgroundColor: pendingProgressBackgroundColor }}
            now={progressWidth}
            key={i}
          />
        );
      } else {
        currentProgressBarElement = (
          <ProgressBar variant="primary" now={progressWidth} key={i} />
        );
      }
    }
    progressBarElements.push(currentProgressBarElement);

    currentProgressBarLabelElement = (
      <ProgressBar
        className="text-dark"
        variant="white"
        style={{
          fontWeight:
            availableStatuses[i].value === currentStatus ? "bold" : "normal",
          whiteSpace: "break-spaces",
        }}
        now={progressWidth}
        label={availableStatuses[i].label}
        key={i}
      />
    );
    progressBarLabelElements.push(currentProgressBarLabelElement);
  }

  //last stauts is special cause it'll use the full available width
  const lastIndex = availableStatuses.length - 1;
  if (availableStatuses[lastIndex].value === currentStatus) {
    currentProgressBarElement = (
      <ProgressBar
        variant="primary"
        now={progressWidth + progressWidth / 2}
        key={lastIndex}
      />
    );
  } else {
    currentProgressBarElement = (
      <ProgressBar
        style={{ backgroundColor: pendingProgressBackgroundColor }}
        now={progressWidth + progressWidth / 2}
        key={lastIndex}
      />
    );
  }

  progressBarElements.push(currentProgressBarElement);

  currentProgressBarLabelElement = (
    <ProgressBar
      className="text-dark"
      variant="white"
      style={{
        fontWeight:
          availableStatuses[lastIndex].value === currentStatus
            ? "bold"
            : "normal",
        whiteSpace: "break-spaces",
      }}
      now={progressWidth}
      label={availableStatuses[lastIndex].label}
      key={lastIndex}
    />
  );
  progressBarLabelElements.push(currentProgressBarLabelElement);

  return (
    <Row style={{ marginTop: "20px" }}>
      <Col className="col-12 col-md-12">
        <ProgressBar style={{ height: "1.2rem", fontSize: "0.9rem" }}>
          {progressBarElements}
        </ProgressBar>
        <ProgressBar style={{ height: "5rem", fontSize: "0.95rem" }}>
          {progressBarLabelElements}
        </ProgressBar>
      </Col>
    </Row>
  );
};
